<template>
  <div>
    <v-dialog v-model="visible" max-width="800px">
      <v-card>
        <v-toolbar color="#f9f9f9">
          <v-toolbar-title>健康告知</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="visible = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <ul class="health-list">
            <li>1、过去二年内是否曾因接受健康检查有异常情形而被建议接受其它检查或治疗？</li>
            <li>2、最近二个月内是否曾因受伤或生病接受医师诊治或用药？</li>
            <li>3、过去五年内是否因受伤或生病住院治疗七日以上？</li>
            <li>
              4、是否曾患有下列一项或多项疾病而接受医师诊治、用药？
              <ul>
                <li>(1)高血压症、心肌病、主动脉血管瘤，心脏瓣膜疾病、心博过缓性或心博过速性心律不整？ </li>
                <li>(2)脑中风（脑出血、脑栓塞、脑梗塞）、短暂性脑缺血、脑瘸、脑动脉血管瘤、脑静动脉畸形、多发性硬化症、癫痫、肌肉萎缩症、脊髓病变、重症肌无力、巴金森氏症、精神病？ </li>
                <li>(3)肺气肿、支气扩张症、尘肺症、肺结核？</li>
                <li>(4)肝炎、肝炎病毒携带者、肝内结石、肝硬化、肝功能异常? </li>
                <li>(5)肾脏炎、肾病症候群、肾机能不全、尿毒症、肾囊肿？ </li>
                <li>(6)视网膜出血或剥离、视神经病变？</li>
                <li>(7)癌症（恶性肿瘤）或未经证实为良性或恶性之肿瘤、胃或大肠息肉？</li>
                <li>(8)血友病、白血病、贫血、紫斑症?</li>
                <li>(9)糖尿病、类风湿性关节炎、肢端肥大症、脑下垂体机能亢进或低下、肾上腺功能亢进或低下？</li>
                <li>(10)红斑性狼疮、胶原症？</li>
                <li>(11)艾滋病或艾滋病携带者?</li>
                <li>(12)酒精或药物溢用成瘾、眩晕症、脑震荡、肢体麻痹？</li>
                <li>(13)食道、胃、十二指肠溃疡或出血、溃疡性大肠炎、胰脏炎？</li>
                <li>(14)肝脓疡、黄疽，肝或脾肿大? </li>
                <li>(15)慢性支气管炎、气喘、肺脓疡、肺栓塞？</li>
                <li>(16)痛风、高血脂症、青光眼、白内障？ </li>
                <li>(17)乳腺炎、乳漏症、子宫内膜异位症，阴道异常出血（女性被保险人回答）？</li>
              </ul>
            </li>
            <li>5、目前身体状况是否失明，聋哑，言语、咀嚼、四肢机能障碍？</li>
            <li>6、投保前过去一年内是否仍患有下列疾病? 肺炎、支气管炎、气胸、肋膜炎、疝气、痔疮、胆结石、胆囊炎、慢性胃炎、尿道结石或发炎、骨盆腔发炎、甲状腺肥大或发炎、脑膜炎、 头部外伤、骨折、脑性麻痹、弱视、角膜疾病，乳突炎、中耳炎、梅尼尔氏症、鼻窦炎、鼻中隔弯曲、淋巴腺肿大、椎间盘突出、关节炎、 甲状腺肿、肾上腺疾病、良性肿瘤、静脉曲张、血管瘤、蛋白尿、血尿？</li>
            <li>7、是否有跛行、脊柱或胸廓畸形、四肢（含手指、足址）缺损或畸形、听力障碍、嗅觉障碍、中枢神经系统障碍？</li>
          </ul>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  }
};
</script>



